import { ChevronRightIcon } from '@chakra-ui/icons';
import { Box } from '@chakra-ui/react';
import cx from 'classnames';
import React from 'react';

import ActionSection from '../../../../ActionSection';
import { NavItem } from '../../../../types';
import UtilitySection from '../../../../UtilitySection';
import { useNavigation } from '../../../Navigation.context';
import Subnavigation from '../../../Subnavigation/Subnavigation';
import * as Styles from './MainNavigationMenu.module.scss';

interface MainNavigationMenuProps {}

interface MainNavigationItemProps {
  index: number;
  item: NavItem;
  isSelected: boolean;
  onSelected: (index: number) => void;
}

const MainNavigationItem: React.FC<MainNavigationItemProps> = ({
  index,
  item,
  isSelected,
  onSelected,
}) => {
  const handleClick = React.useCallback(() => {
    onSelected(index);
  }, [index, onSelected]);

  const hasSubnav = item.subnavigation.length > 0;
  return (
    <li
      className={cx(Styles.Menu__ListItem, {
        [Styles.Menu__ListItemHasChildren]: hasSubnav,
      })}
    >
      <button
        className={cx(Styles.Menu__ListItem__Link, {
          [Styles.Menu__ListItem__LinkActive]: isSelected,
        })}
        onClick={handleClick}
        onKeyDown={(e) => (e.key === 'enter' ? handleClick : undefined)}
        aria-expanded={isSelected ? true : false}
        tabIndex={0}
      >
        <span className={Styles.Menu__ListItem__Link__Text}>
          {item.item}
          {hasSubnav && (
            <ChevronRightIcon className={Styles.Menu__ListItem__Link__Arrow} />
          )}
        </span>
      </button>
      {isSelected && <Subnavigation />}
    </li>
  );
};

const MainNavigationMenu: React.FC<MainNavigationMenuProps> = () => {
  const { data, main } = useNavigation();

  return (
    <nav
      className={cx(Styles.MainNavigationMenu, {
        [Styles.MenuVisible]: main.active,
      })}
    >
      <ul className={Styles.Menu__List}>
        {data.menu.main.map((menuItem, index) => (
          <MainNavigationItem
            key={index}
            index={index}
            item={menuItem}
            isSelected={index === main.selectedIndex}
            onSelected={main.selectItem}
          />
        ))}
      </ul>
      <UtilitySection />
      <Box display={{ base: 'block', laptop: 'none' }}>
        <ActionSection />
      </Box>
    </nav>
  );
};

export default MainNavigationMenu;
